import React, {Fragment} from "react";
import ImportButton from "../../../form/ImportButton";
import TextInput from "../../../form/TextInput";
import Papa from "papaparse";
import DataGrid from "../../../form/SelectorGrid/DataGrid";
import Button from "../../../form/Button";
import Collapse from "../../../layout/Collapse";
import {isEqual} from "lodash-es";
import {set} from "../../../../utils/dotutils";
import Select from "../../../form/Select";
import XLSX from "xlsx";
import Field from "../../../form/SelectorGrid/DataGrids/Field";
import Tabs from "../../../layout/Tabs";
import TabContent from "../../../layout/TabContent";

class CSV {
    static build(data, props) {
        return new Promise(resolve => {
            Papa.parse(data, {
                quoteChar: props.value?.enclosure,
                escapeChar: props.value?.escape,
                delimiter: props.value?.delimiter,
                newline: props.value?.linebreak,
                complete: (results) => {
                    resolve({
                        meta: {
                            delimiter: results.meta.delimiter,
                            linebreak: results.meta.linebreak
                        },
                        data: results.data
                    });
                }
            })
        });
    }
    static parse(file) {
        return new Promise(resolve => {
            let reader = new FileReader();
            reader.onload = result => {
                resolve(result.target.result);
            };
            reader.readAsText(file);
        });
    }
    static parameters(props) {
        return <Fragment>
            <div className="col-md-6">
                <div className="form-group">
                    <TextInput
                        label="Elválasztó karakter"
                        name="delimiter"
                        value={escape(props.value?.delimiter || '')}
                        saveChanges={(field, value) => props.saveChanges(field, unescape(value))}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <Select
                        storeType="local"
                        labelKey="label"
                        valueKey="value"
                        disabled={true}
                        options={["\\n","\\r","\\r\\n"].map((k) => ({value: k, label: k}))}
                        label="Sortörés"
                        name="linebreak"
                        objectValue={false}
                        value={escape(props.value?.linebreak || '')}
                        saveChanges={(field, value) => props.saveChanges(field, unescape(value))}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <TextInput
                        label="Oszlop elválasztó karakter"
                        name="enclosure"
                        value={escape(props.value?.enclosure || '')}
                        saveChanges={(field, value) => props.saveChanges(field, unescape(value))}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <TextInput
                        label="Elválasztó karakter"
                        name="escape"
                        value={escape(props.value?.escape || '')}
                        saveChanges={(field, value) => props.saveChanges(field, unescape(value))}
                    />
                </div>
            </div>
        </Fragment>
    }
}

class Xls {
    static build(data, props) {
        return new Promise(resolve => {
            let workbook = XLSX.read(data, {
                type: 'binary'
            });

            let defaultSheet = null;
            if (workbook?.Workbook?.WBView?.[0]?.activeTab) {
                defaultSheet = workbook.SheetNames[workbook.Workbook.WBView[0].activeTab];
            }

            let sheet = props?.value?.sheet || defaultSheet || workbook.SheetNames[0];

            //workbook.SheetNames.forEach(function(sheet) {
                resolve({
                    meta: {
                        sheets: workbook.SheetNames,
                        sheet
                    },
                    data: XLSX.utils.sheet_to_json<object>(workbook.Sheets[sheet], {
                        defval: "",
                        header: 1
                    }).reduce((rows, row) => ([...rows, Object.values(row)]), [])
                });
            //})
        });
    }
    static parse(file) {
        return new Promise(resolve => {
            let reader = new FileReader();
            reader.onload = result => {
                resolve(result.target.result);
            };
            reader.readAsBinaryString(file);
        });
    }
    static parameters(props) {
        let activeSheet = props?.value?.sheet;
        return <Fragment>
            <div className="col-md-12">
                <div className="form-group">
                    <Tabs
                        className="no-margin"
                        currentTab={activeSheet}
                        defaultTab={(props?.value?.sheets || [])[0]}
                        onTabChange={(sheet) => props.saveChanges("sheet", sheet)}
                    >
                    {props?.value?.sheets && (props?.value?.sheets || []).map((sheet) => {
                        return <TabContent
                            tabLabel={sheet}
                            tabName={sheet}
                        />
                    })}
                    </Tabs>
                </div>
            </div>
        </Fragment>
    }
}

const getProcessor = (filetype) => {
    switch (filetype) {
        case "csv":
            return CSV;
        case "xls":
        case "xlsx":
            return Xls;
    }
}

const escape = (str) => str.replace(/\v/,"\\v").replace(/\f/,"\\f").replace(/\b/,"\\b").replace(/\n/,"\\n").replace(/\r/,"\\r").replace(/\t/,"\\t");
const unescape = (str) => str.replace(/\\v/, "\v").replace(/\\f/, "\f").replace(/\\b/, "\b").replace(/\\n/, "\n").replace(/\\r/,"\r").replace(/\\t/,"\t");

type FilterListerProps = {
    value?: {
        columns: {[name: string]: null|number},
        firstRowIsAHead?: number,
        type?: string,
        data?: object[]
    },
    name: string,
    component: string,
    saveChanges: (field: string, value: any) => void,
    queryFields: {
        name: string,
        label: string,
        operators: {
            name: string,
            label: string,
            valueEditor: (props) => any,
        }[]
    }[]
}

type FilterListerState = {
    opened?: boolean,
    data?: any[],
}

export default class FileLister extends React.Component<FilterListerProps, FilterListerState> {

    state = {
        opened: false,
        data: [],
    }

    constructor(props) {
        super(props);
        this.build();
    }

    build = () => {
        let Processor = getProcessor(this.props.value?.type);
        if (Processor) {
            Processor.build(this.props.value?.data, this.props).then(results => {
                this.props.saveChanges(this.props.name, {
                    ...(this.props.value || {}),
                    ...results.meta
                });
                this.setState({data: results.data});
            });
        } else {
            this.setState({
                opened: false,
                data: [],
            });
        }
    }

    saveChanges = (field, value) => {
        const v = JSON.parse(JSON.stringify(this.props.value));
        set(v, field, value);
        this.props.saveChanges(this.props.name, v);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(this.props.value, prevProps.value)) {
            this.build();
        }
    }

    render() {
        const selectedColumns = this.props.value?.columns || {
            name: null,
            email: null,
        };
        const columns = this.props.value?.firstRowIsAHead ? [...(this.state.data[0] || [''])] : [...Array(this.state.data?.[0]?.length || 0).keys()].map((key) => key + "");
        const Parameters = getProcessor(this.props.value?.type)?.parameters;
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <ImportButton
                                label="Lista fájl"
                                name="file"
                                saveChanges={(field, file) => {
                                    let filetype = (file?.name || "").split(".").pop().toLowerCase();
                                    const Processor = getProcessor(filetype);
                                    if (Processor) {
                                        Processor.parse(file).then((result) => {
                                            this.props.saveChanges(this.props.name, {
                                                ...(this.props.value || {}),
                                                type: filetype,
                                                data: result,
                                            });
                                        });
                                    } else {
                                        this.props.saveChanges(this.props.name, {
                                            ...(this.props.value || {}),
                                            type: undefined,
                                            data: undefined,
                                        });
                                    }
                                }}
                            />
                        </div>
                    </div>
                    {!!this.state.data.length &&
                        <Fragment>
                            {Object.entries(selectedColumns).map(([column, idx]) => {
                                return <div key={column} className="col-md-6">
                                    <div className="form-group">
                                        <TextInput
                                            type="number"
                                            label={column}
                                            name={column}
                                            value={idx}
                                            placeholder={"1-" + String(columns.length) + " oszlop száma"}
                                            error={idx > columns.length || (idx !== undefined && idx !== null && idx !== "" && idx < 1) ? "Hibás oszlop szám!" : null}
                                            saveChanges={(field, value) => this.saveChanges("columns", {...selectedColumns, [field]: value === "" ? null : value})}
                                        />
                                    </div>
                                </div>;
                            })}
                            <div className="col-md-12">
                                <Button block={true} color={this.state.opened ? "primary" : "default"} icon={{lib: "fas", name: "pencil-alt"}} onClick={() => this.setState({opened: !this.state.opened})}/>
                            </div>
                            <Collapse collapsed={!!this.state.opened}>
                                <div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <TextInput
                                                type="number"
                                                label="Fejléc sorok száma"
                                                name="firstRowIsAHead"
                                                value={this.props.value?.firstRowIsAHead}
                                                saveChanges={(field, value) => this.saveChanges(field, value)}
                                            />
                                        </div>
                                    </div>
                                    {Parameters && <Parameters {...this.props} saveChanges={this.saveChanges} />}
                                </div>
                            </Collapse>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <DataGrid
                                        className="p-small-table"
                                        value={this.state.data.filter((row, idx) => {
                                            if (this.props.value?.firstRowIsAHead > idx) {
                                                return false;
                                            }
                                            return true;
                                        }).map((rowData) => {
                                            let row = {};
                                            columns.map((column, idx) => {
                                                row[column] = rowData[idx];
                                            });
                                            return row;
                                        })}
                                    >
                                        {columns.map((column, idx) => {
                                            const selected = Object.entries(selectedColumns).some(([_column, _idx]) => idx + "" === "" + (Number(_idx) - 1));
                                            return <Field
                                                key={idx}
                                                style={{
                                                    fontWeight: selected ? "bold" : null,
                                                    backgroundColor: selected ? "rgba(0,255,0,.2)" : null
                                                }}
                                                field={column}
                                                header={<Fragment>{column + "" !== "" + idx ? `${column} - ` : ''}<i>{Number(idx)+1}. oszlop</i></Fragment>}
                                                sortable={true}
                                                filterable={true}
                                            />
                                        })}
                                    </DataGrid>
                                </div>
                            </div>
                        </Fragment>
                    }
                </div>
                <div className="form-group">
                    <div className="form-control">
                        <b>{this.state?.data?.length || 0}</b> Feliratkozó van a feltételeknek megfelelően
                    </div>
                </div>
            </Fragment>
        );
    }
}